import { BottomSheet } from '@betty/navigation';
import { AppDispatch } from '@betty/toolkit/state';
import { TextProps } from '@betty/moonlight';
import { openDeposit } from '@betty/wallet/state';

export type StatusConfig = {
  textProps: Pick<TextProps, 'locKey' | 'locNS'>;
  action: (dispatch: AppDispatch) => void;
};

export const STATUS_CONFIG: Record<string, StatusConfig> = {
  Approved: {
    textProps: { locNS: 'common', locKey: 'deposit' },
    action: (dispatch) => dispatch(openDeposit()),
  },
  Pending: {
    textProps: { locNS: 'common', locKey: 'verifyIdentity' },
    action: () =>
      BottomSheet.open({
        namespace: 'onboarding',
        type: 'OnfidoEntry',
      }),
  },
  DEFAULT: {
    textProps: { locNS: 'common', locKey: 'deposit' },
    action: (dispatch) => dispatch(openDeposit()),
  },
};
